module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-scrollDiv', {
    staticClass: "wrap-dashboard"
  }, [_c('div', {
    staticClass: "item-box user"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/dash-user.svg")
    }
  }), _vm._v("个人信息\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-add"
  }, [_vm._v(_vm._s(_vm.user.position_name))]), _vm._v(" "), _c('z-lazyImg', {
    staticClass: "userimg",
    attrs: {
      "src": _vm.userInfo.userLogo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', [_c('div', {
    staticClass: "overhide"
  }, [_vm._v("姓名："), _c('span', {
    attrs: {
      "title": _vm.user.real_name
    }
  }, [_vm._v(_vm._s(_vm.user.real_name))])]), _vm._v(" "), _c('div', [_vm._v("职级："), _c('span', [_vm._v(_vm._s(_vm.user.staffing_grade))])])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("工号："), _c('span', [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _c('div', [_vm._v("身份："), _c('span', [_vm._v(_vm._s(_vm.user.bu_identity_type == 1 ? "合伙人" : "职员"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info overhide"
  }, [_vm._v("所属BU："), _c('span', {
    attrs: {
      "title": _vm.bu.bu_name
    }
  }, [_vm._v(_vm._s(_vm.bu.bu_name))])]), _vm._v(" "), (_vm.userInfo.bu.type == 0) ? _c('p', [_vm._v("经营范围")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sub_range))])])]), _vm._v(" "), (_vm.code(1000)) ? _c('div', {
    staticClass: "item-box task"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/dash-task.svg")
    }
  }), _vm._v("任务管理\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big font"
  }, [_vm._v(_vm._s(_vm.task.solve_size))]), _vm._v("件")]), _vm._v(" "), _c('div', [_vm._v("待处理任务")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.task.release_size))]), _vm._v("件")]), _vm._v(" "), _c('div', [_vm._v("待发布任务")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.task.end_size))]), _vm._v("件")]), _vm._v(" "), _c('div', [_vm._v("已结束任务")])])])])]) : _vm._e(), _vm._v(" "), (_vm.code(1200)) ? _c('div', {
    staticClass: "item-box doc"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/dash-doc.svg")
    }
  }), _vm._v("文档管理\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big font"
  }, [_vm._v(_vm._s(_vm.doc.all_doc_size))]), _vm._v("份")]), _vm._v(" "), _c('div', [_vm._v("文档")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.doc.task_doc_size))]), _vm._v("份")]), _vm._v(" "), _c('div', [_vm._v("任务文档")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.doc.task_tpl_doc_size))]), _vm._v("份")]), _vm._v(" "), _c('div', [_vm._v("文档模板")])])])])]) : _vm._e(), _vm._v(" "), (_vm.code(1300)) ? _c('div', {
    staticClass: "item-box bu special",
    on: {
      "mouseenter": function($event) {
        _vm.move_flag = true
      },
      "mouseleave": function($event) {
        _vm.move_flag = false
      }
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "text-title"
  }, [_c('img', {
    attrs: {
      "src": require("src/assets/image/dash-bu.svg")
    }
  }), _vm._v("BU管理\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-add"
  }, [_vm._v(_vm._s(_vm.data.bonusCycleDetail && ((_vm.data.bonusCycleDetail.cycle_year) + "#" + (_vm.data.bonusCycleDetail.cycle_number))))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "big font"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.curr.current_currency_balance)))]), _vm._v(_vm._s(_vm.curr.currency_name))]), _vm._v(" "), _c('div', [_vm._v("BU奖金")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.data.pmtLevelSummary && _vm.data.pmtLevelSummary.balance || 0))]), _vm._v("级")]), _vm._v(" "), _c('div', [_vm._v("可分配职级")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-item"
  }, [_c('div', [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.data.ticketSum && _vm.data.ticketSum.ticket_sum))]), _vm._v("币")]), _vm._v(" "), _c('div', [_vm._v("BU罚单币")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-77439c5b!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/page-dashboard.vue
// module id = 766
// module chunks = 1